import React from 'react';
import { useQuery } from '@tanstack/react-query';
import '../styles/views/team-showcase.css';
import { formatEmployeeExperience } from '../utils/employee';

function TeamCard({ employee }) {
  return (
    <div className="team-card">
      <div className="team-card__media">
        {employee.photo_url ? (
          <img
            src={employee.photo_url}
            alt={employee.name}
            className="team-portrait team-card__img"
          />
        ) : (
          <div className="font-display team-card__placeholder">
            {employee.name.slice(0, 2).toUpperCase()}
          </div>
        )}
      </div>
      <h3 className="font-display team-card__name">
        {employee.name}
      </h3>
      <p className="font-label team-card__role">
        {employee.role}
      </p>
      {formatEmployeeExperience(employee) && <p className="team-card__experience">{formatEmployeeExperience(employee)}</p>}
    </div>
  );
}

export default function TeamShowcase() {
  const { data, isLoading } = useQuery({
    queryKey: ['employees'],
    queryFn: async () => {
      const res = await fetch('/api/employees');
      return res.json();
    }
  });

  const employees = data?.employees || [];
  const permanentStaff = employees.filter(e => e.employment_type === 'permanent');
  const temporaryStaff = employees.filter(e => e.employment_type === 'temporary');

  return (
    <div className="section">
      <div className="team-page__header">
        <p className="font-label team-page__eyebrow">
          PESSOAS E CULTURA
        </p>
        <h1 className="font-display team-page__title">
          Equipe e Colaboradores
        </h1>
        <p className="team-page__intro">
          Arquitetos, urbanistas e pesquisadores unidos pela busca da excelência tectônica. Nossa equipe reúne profissionais permanentes e colaboradores especializados por projeto.
        </p>
      </div>

      {isLoading ? (
        <p className="loading-note">Carregando equipe...</p>
      ) : (
        <>
          <div className="team-group">
            <h2 className="font-label team-group__heading">
              Equipe Permanente
            </h2>
            <div className="team-grid">
              {permanentStaff.map((emp) => (
                <TeamCard key={emp.id} employee={emp} />
              ))}
            </div>
          </div>

          {temporaryStaff.length > 0 && (
            <div>
              <h2 className="font-label team-group__heading">
                Colaboradores por Projeto
              </h2>
              <div className="team-grid">
                {temporaryStaff.map((emp) => (
                  <TeamCard key={emp.id} employee={emp} />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
